import activitiesTab from './activitiesTab';

export default [
  activitiesTab,
];
